import { createStyles } from '@mantine/core';

import { titleStyles } from '~/domains/design-system/Title';

const ICON_CONTAINER_SIZE = 40;

export const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.white,
    borderRadius: theme.other.card.radius,
    border: `1px solid ${theme.colors.gray2[1]}`,
    overflow: 'hidden',
  },
  bonusRow: {
    padding: theme.other.spacing._16,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.other.spacing._12,
    flexShrink: 0,
    width: ICON_CONTAINER_SIZE,
    height: ICON_CONTAINER_SIZE,
  },
  textContent: {
    flex: 1,
    gap: theme.other.spacing._4,
    minWidth: 0,
  },
  detailsLink: {
    ...titleStyles['subhead-medium'],
  },
  predictionMarketsWarning: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
    borderTop: `1px solid ${theme.colors.yellow[6]}4D`,
    backgroundColor: `${theme.colors.yellow[6]}26`,
  },
  predictionMarketsWarningIcon: {
    flexShrink: 0,
    color: theme.fn.darken(theme.colors.yellow[8], 0.3),
  },
  predictionMarketsWarningCopy: {
    color: theme.fn.darken(theme.colors.yellow[8], 0.54),
  },
}));
